var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner"},[_c('Spinner',{attrs:{"big":true}}),_c('h2',{staticClass:"loading-spinner__title"},[_vm._v("Straks klar!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }